<!-- 基本信息 -->
<template>
  <div>
    <div class="caseDataParent ly-border-radius">
      <div class="caseDataParent_type">
        <div class="tabs">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="基本信息" name="basicInfo">
              <BasicInfo @echoCategoryId="echoCategoryId" ref="basicInfo"></BasicInfo>
            </el-tab-pane>

            <el-tab-pane label="规格信息" name="specificationInfo">
              <SpecificationInfo ref="specificationInfo"></SpecificationInfo>
            </el-tab-pane>

            <el-tab-pane label="实体关联" name="entityAssociation">
              <EntityAssociation ref="entityAssociation"></EntityAssociation>
            </el-tab-pane>

            <el-tab-pane label="数据日志" name="dataEementInfo">
              <DataEementInfo></DataEementInfo>
            </el-tab-pane>
          </el-tabs>
        </div>

        <div class="bottom">
          <el-button type="primary" @click="saveItem(activeName)">保存</el-button>
          <el-button @click="cancelItem">取消</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 基本信息
import BasicInfo from "./components/BasicInfo.vue";

// 规格信息
import SpecificationInfo from "./components/SpecificationInfo.vue";

// 数据元信息
import DataEementInfo from "./components/DataEementInfo.vue";
import EntityAssociation from "@/views/Product/editProduct/components/EntityAssociation.vue";

export default {
  name: "productClassifyInfo",
  components: {
    EntityAssociation,
    BasicInfo,
    SpecificationInfo,
    DataEementInfo
  },
  data() {
    return {
      activeName: "basicInfo",
      productCode: this.$route.query.productCode
    };
  },
  computed: {},
  watch: {
    activeName(value, oldValue) {
      if(this.productCode) {
        this.getInfo(value);
        // this.saveItem(oldValue);
      }
    }
  },
  mounted() {
    if(this.productCode) {
      this.$nextTick(() => {
        this.getInfo(this.activeName);
      });
    }
  },
  methods: {
    echoCategoryId(categoryId) {
      this.productCode = categoryId;
      this.$route.query.productCode = categoryId;
    },
    getInfo(activeName) {
      switch (activeName) {
        case "specificationInfo":
          this.$refs.specificationInfo.getInfo();
          break;
        case "basicInfo":
          this.$refs.basicInfo.getInfo();
          break;
        case "entityAssociation":
          this.$refs.entityAssociation.getInfo();
          break;
      }
    },
    saveItem(activeName) {
      switch (activeName) {
        case "specificationInfo":
          this.$refs.specificationInfo.submit();
          break;
        case "basicInfo":
          if(this.productCode) {
            this.$refs.basicInfo.submit();
          } else {
            this.$refs.basicInfo.saveBasicInfo();
          }
          break;
        case "entityAssociation":
          if(this.productCode) {
            this.$refs.entityAssociation.submit();
          } else {
            this.$message.error("请先保存基础信息！")
          }
          break;
      }
    },
    cancelItem() {
      this.$router.go(-1);

      this.$router.push({
        path: "/productClassify"
      });
    },
    handleClick() {}
  }
};
</script>

<style lang="less" scoped>
.caseDataParent_type {
  padding: 0 20px;
}

.tabs {
  min-height: calc(100vh - 176px);
}

.caseDataParent {
  overflow: hidden;
  background-color: #fff;

  /deep/ .el-tabs__content {
    overflow: auto;
  }
}
.bottom {
  border-top: 1px solid #dbdbdb;
  background: #fff;
  padding: 10px 20px;
  display: flex;
  justify-content: center;
  .el-button {
    margin: 0 20px;
  }
}
</style>
